import React from "react";

const LazyResetPassword = React.lazy(() => import("./reset-password"));

const ResetPassword = (props: Record<string, any>) => (
  <React.Suspense fallback={<div className='transition-loader'><img src='/images/loader.svg' /></div>}>
    <LazyResetPassword {...props} />
  </React.Suspense>
);

export default ResetPassword;
